export * from './closing-popup/closing-popup.component';
export * from './control-changing-confirmation/control-changing-confirmation.component';
